import {PositionMode} from '@px/enum';
import {OrderListType} from '@px/enum/order';

export const orderUtil = {
  isConditionalOrder(ordType) {
    return ['Stop', 'StopLimit', 'LimitIfTouched', 'MarketIfTouched', 'BoSlLimit', 'BoSlMarket'].indexOf(ordType) > -1;
  },
  isLimitOrder(ordType) {
    return ['Bracket', 'StopLimit', 'LimitIfTouched', 'BoTpLimit', 'BoSlLimit'].indexOf(ordType) > -1;
  },
  isMarketOrder(ordType) {
    return ['Market', 'Stop', 'MarketIfTouched', 'BoSlMarket'].indexOf(ordType) > -1;
  },
  isBracketOrders(ordType) {
    return ['Bracket', 'BoTpLimit', 'BoSlLimit', 'BoSlMarket'].indexOf(ordType) > -1;
  },
  isFinalOrder(ordStatus) {
    return ['Deactivated', 'Filled', 'Canceled', 'Rejected'].indexOf(ordStatus) > -1;
  },
  isActivation(ordStatus, pegPriceType: PegPriceType) {
    return ['TrailingTakeProfitPeg', 'TrailingTakeProfitByProportionPeg'].includes(pegPriceType) && ordStatus === 'Inactive';
  },
  /**
   * 修改Tp/Sl前提条件
   * 1. USDT合约
   * 2. Hedge 开仓订单，close 仓位订单不支持
   * 3. 未成交（部分成交不支持修改）
   * 4. one way的reduce only订单，不支持设置tpsl订单，在place order区域会拒绝，在order区域也需要隐藏掉tpsl设置的入口
   * 5. 追踪委托订单暂不支持
   * 6. OCO订单不支持
   * */
  canEditTpsl(contract, order, posMode) {
    const {type} = contract;
    if (type === 'Perpetual') {
      return false;
    }
    const {side, posSide, execInst, ordStatus, displayOrdType, orderListType} = order;
    if (displayOrdType === 'TrailingStop' || orderListType === OrderListType.OCO) {
      return false;
    }
    const isPartiallyFillOrder = ['PartiallyFilled'].includes(ordStatus);
    const isOpenOrder = (side === 'Buy' && posSide === 'Long') || (side === 'Sell' && posSide === 'Short');
    const isReduceOrder = ['ReduceOnly', 'CloseOnTrigger'].includes(execInst);
    return posMode === PositionMode.Hedge ? !isPartiallyFillOrder && isOpenOrder : !isReduceOrder && !isPartiallyFillOrder;
  },
};
